<script>
import Modal from '../../Modal.vue'

export default {
    components: {
        Modal
    },

    props: {
        jobApplication: {
            type: Object,
            required: true
        },
        csrfToken: {
            type: String,
            required: true
        },
        buttonText: {
            type: String,
            default: 'Upload Manually'
        },
        buttonClass: {
            type: String,
            default: 'button primary'
        }
    },

    methods: {
        toggleModal() {
            this.$refs.modal.toggle()
        },
    }
}
</script>

<template>
    <span class="ifact-form-upload">
        <button :class="buttonClass" @click="toggleModal">{{ buttonText }}</button>
        <modal ref="modal" heading="Upload the iFacts form for the candidate.">
            <form
                :action="`/recruiter/active-requisitions/upload-ifact-form/${jobApplication.id}`" method="post"
                enctype="multipart/form-data">
                <input type="hidden" name="_csrfToken" :value="csrfToken" />
                <div class="grid-x grid-padding-x">
                    <div class="cell shrink">
                        <input type="file" name="document_url" id="file" accept=".pdf">
                    </div>
                </div>
                <div class="grid-x grid-padding-x">
                    <div class="cell shrink">
                        Has this candidate ever been convicted of an offence?
                    </div>
                    <div class="cell shrink">
                        <select class="form-control" name="is_ever_convicted" id="is_ever_convicted" required>
                            <option value=""> -Select- </option>
                            <option value="0">No</option>
                            <option value="1">Yes</option>
                        </select>
                    </div>
                </div>
                <div>
                    <button class="btn btn-success mycalling-green upload" type="submit">Upload</button>
                </div>
            </form>
            <div class="grid-x grid-padding-x align-right">
                <div class="cell shrink">
                    <button class="button warning" type="button" @click="toggleModal">Close</button>
                </div>
            </div>
        </modal>
    </span>
</template>